import { FormControl, InputLabel, MenuItem } from '@mui/material';
import {
  BaseWidget,
  BaseWidgetProps,
  Config,
  FactoryWithContext,
  MultiSelectFieldSettings,
  RuleValue,
} from '@react-awesome-query-builder/mui';
import { useContext } from 'react';

import { isTemplatePlaceholder, TemplatePlaceholder } from '@/types';
import { SearchTemplatePageContext } from '@/context/SearchTemplateContext';
import TemplateCapableSelect from './templateCapableComponents/TemplateCapableSelectV2';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';

export interface SelectEntity {
  value: string;
  title: string;
}

type SelectWidgetValue = RuleValue;

type SelectWidgetProps = {
  listValues: SelectEntity[];
  label2: string;
  templateBuilderDisplayName?: string;
};

type CombinedProps = BaseWidgetProps<Config, SelectWidgetValue> & SelectWidgetProps;

const SelectWidgetFactory: FactoryWithContext<CombinedProps> = ({
  listValues,
  value,
  setValue,
  label2,
  templateBuilderDisplayName,
}: CombinedProps) => {
  const isOnTemplatePage = useContext(SearchTemplatePageContext);

  const isPlaceHolder = isTemplatePlaceholder(value);

  const handleChange = (selectValue: string | TemplatePlaceholder) => {
    setValue(selectValue);
  };

  return (
    <FormControl fullWidth focused={isPlaceHolder}>
      <InputLabel id="select-label" sx={{ backgroundColor: 'white', paddingLeft: '5px', paddingRight: '6px' }}>
        {label2}
      </InputLabel>

      <TemplateCapableSelect
        value={value}
        labelId={'select-label'}
        variant="outlined"
        sx={{ minWidth: '20ch', textAlign: 'left' }}
        size="medium"
        onChange={handleChange}
        isOnTemplatePage={isOnTemplatePage}
        valueAfterRemovePlaceholder={listValues[0].value}
        templateBuilderDisplayName={templateBuilderDisplayName}
      >
        {listValues.map((x) => (
          <MenuItem key={x.value} value={x.value}>
            {x.title}
          </MenuItem>
        ))}
      </TemplateCapableSelect>
    </FormControl>
  );
};

export const selectWidget: BaseWidget & MultiSelectFieldSettings<AutocompleteGenericEntity[]> = {
  type: 'select',
  hideOperator: true,
  operatorInlineLabel: ' ',
  asyncFetch: true,
  useAsyncSearch: true,
  showSearch: true,
  allowCustomValues: true,
  factory: SelectWidgetFactory,
};
